import api from "../../utils/api";
import { persistSurveySession } from "../../utils/survey-session";

import {
    LOGOUT,
    USER_LOADED,
    AUTH_ERROR,
    LOGIN_SUCCESS,
    LOGIN_FAILED
} from "../types";

export const tokenize = (instance, token) => async (dispatch) => {
    try {
        if (!persistSurveySession({ instance, token })) {
            throw new Error("Survey tokenization parameters are incomplete.");
        }
        const res = await api.get("/users/me", { skipAuthRedirect: true });
        const licensedInstance = res.data?.instance;
        if (!persistSurveySession({ instance: licensedInstance, token })) {
            throw new Error("No licensed Survey workspace was returned.");
        }
        dispatch({
            type: LOGIN_SUCCESS,
            payload: {
                token,
                instance: licensedInstance,
                user: res.data,
            },
        });

        return true;
    } catch (error) {
        console.log(error);
        dispatch({
            type: LOGIN_FAILED,
        });
    }
    return false;
}


export const get = () => async (dispatch) => {
    try {
        const res = await api.get("/users/me");
        if (res.data?.instance && localStorage.token) {
            persistSurveySession({
                instance: res.data.instance,
                token: localStorage.token,
            });
        }
        dispatch({
            type: USER_LOADED,
            payload: res.data,
        });
        return res.data;
    } catch (err) {
        dispatch({
            type: AUTH_ERROR,
        });
    }
}

export const logout = () => async (dispatch) => {
    dispatch({ type: LOGOUT });
};
